export const VegetarianDishList = [
  '素菜测试1',
  '素菜测试2',
  '素菜测试3',
  '素菜测试4'
];

export const ChivesList = ['荤菜测试1', '荤菜测试2', '荤菜测试3', '荤菜测试4'];

export const CookMethodsList = ['蒸', '炒', '灼'];
